// extracted by mini-css-extract-plugin
export default {"content-root":"_35uhe","contentRoot":"_35uhe","title":"_2mJZY","message":"_1vuB5","image":"_2G0vf"};